import { render, staticRenderFns } from "./faq-wrapper.vue?vue&type=template&id=5ad6177a&scoped=true&"
import script from "./faq-wrapper.vue?vue&type=script&lang=js&"
export * from "./faq-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./faq-wrapper.vue?vue&type=style&index=0&id=5ad6177a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad6177a",
  null
  
)

export default component.exports